import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '@spartacus/core';
import { RecaptchaComponent, RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { ViewportScroller, DecimalPipe, DatePipe } from '@angular/common';
import { OrderDeliveryStatus } from '../models/order-delivery-status.model';
import { NyabHomeSearchService } from '../service/nyabhome-search.service';
import { SpinnerComponent } from '@spartacus/storefront';
@Component({
    selector: 'app-nyabhome-page',
    templateUrl: './nyabhome-page.component.html',
    imports: [ReactiveFormsModule, RecaptchaModule, RecaptchaFormsModule, SpinnerComponent, DecimalPipe, DatePipe]
})
export class NYABHomePageComponent implements OnInit, OnDestroy {
  @ViewChild('captacha') captacha!: RecaptchaComponent;
  orderTrackingForm!: FormGroup;
  orrderTrackingResponse!: OrderDeliveryStatus;
  searchInProgress = false;
  subscription = new Subscription();
  captchaResolved = false;
  submitted = false;
  constructor(
    protected service: NyabHomeSearchService,
    protected cdr: ChangeDetectorRef,
    protected routingService: RoutingService,
    protected activatedRoute: ActivatedRoute,
    protected viewportScroller: ViewportScroller
  ) { }

  ngOnInit(): void {
    this.orderTrackingForm = new FormGroup({
      searchTerm: new FormControl('', [Validators.required]),
      nyabRecaptacha: new FormControl(null, Validators.required),
    });
  }
  onSubmit() {
    this.submitted = true;
    if (this.orderTrackingForm.valid) {
      this.searchInProgress = true;
      this.submitted = false;
      this.subscription = this.service
        .getOrderStatus(this.orderTrackingForm.value.searchTerm)
        .subscribe({
          next: (res: OrderDeliveryStatus) => {
            this.setResponseData(res);
          },
          error: (err) => {
            this.setResponseData(err);
          },
        });
    }
  }

  setResponseData(res: OrderDeliveryStatus) {
    this.orrderTrackingResponse = res;
    this.captacha.reset();
    this.searchInProgress = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.viewportScroller.scrollToPosition([
        document.getElementById('result')?.offsetLeft as number,
        (document.getElementById('result')?.offsetTop as number) - 78,
      ]);
    }, 1);
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved =
      captchaResponse && captchaResponse.length > 0 ? true : false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  formatMaterial(materialNum: string) {
    return materialNum?.replace(/^0+/, '');
  }
}
